import React, { useMemo } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { getTimezone } from '../../../utils/timezone';
import TasksWorkspace from '../../../features/tasks/components/TasksWorkspace';
import {
  getPlatformTaskBulkActionsRoute,
  getPlatformTasksRoute,
} from '../../../features/tasks/constants/taskFields';

export default function PlatformTasksPage() {
  const { user } = useAuth();
  const workspace = useMemo(() => ({
    scopeType: 'platform',
    platformId: user?.platform_id || null,
    agencyId: null,
    timezone: user?.timezone || getTimezone() || 'UTC',
    permissions: user?.permissions || [],
    routes: {
      tasks: getPlatformTasksRoute(),
      bulkActions: getPlatformTaskBulkActionsRoute(),
    },
  }), [user]);

  return <TasksWorkspace workspace={workspace} />;
}
